import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import {
  clientCreate,
  clientUpdating,
  getClientList,
} from "actions/clientActions";
import { getProfile } from "actions/userActions";

import MDActionConfigurator from "components/MDActionConfigurator";

function Clients() {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    name: "",
    email: "",
    phone: "",
    idNumber: "",
    date_of_birth: "",
    profile_image: "",
    active: false,
    products: [],
    complaints: [],
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const listClients = useSelector((state) => state.listClients);
  const { clientsList } = listClients;
  console.log("🚀 ~ file: index.js:62 ~ Clients ~ clientsList:", clientsList);

  useEffect(() => {
    if (clientsList?.length === 0) {
      dispatch(getClientList());
    }
  }, [dispatch, clientsList?.length]);

  const handleToggleBackdrop = (item, state) => {
    // item.date_of_birth = ""; //to be removed on d
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitClient = (e) => {
    if (currentState === "edit") {
      dispatch(clientUpdating(currentData?._id, e));
    } else {
      dispatch(clientCreate(e));
    }
    handleToggleBackdrop({}, "");
  };

  const Client = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {name}
        </MDTypography>
        <MDTypography
          variant="caption"
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        >
          {email}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        fontWeight="medium"
      >
        {title}
      </MDTypography>
      <MDTypography
        variant="caption"
        sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
      >
        {description}
      </MDTypography>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        clients: (
          <Link to={`/clients/${item?._id}`}>
            <Client
              key={index}
              image={item.profile_image}
              name={item.name}
              email={item.email}
            />
          </Link>
        ),
        phone: <Job title={item.phone} description="Mobile" />,
        joined: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {moment(item.created_at).format("Do MMMM YYYY")}
          </MDTypography>
        ),
        orders: (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item.orders.length}
          </MDTypography>
        ),
        complaints: (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item.complaints.length}
          </MDTypography>
        ),
        state: (
          <>
            {item?.active ? (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>person</Icon>}
                label="Active"
                variant="outlined"
                color="info"
                sx={{ paddingLeft: 1 }}
              />
            ) : (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>person_off</Icon>}
                label="Inactive"
                color="error"
                sx={{ paddingLeft: 1 }}
              />
            )}
          </>
        ),
        verified: (
          <>
            {item?.email_verified_at ? (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>verified</Icon>}
                label="Verified"
                variant="outlined"
                color="info"
                sx={{ paddingLeft: 1 }}
              />
            ) : (
              <Chip
                icon={<Icon sx={{ fontWeight: "bold" }}>update</Icon>}
                label="Awaiting Verification"
                color="error"
                sx={{ paddingLeft: 1 }}
              />
            )}
          </>
        ),
        // action: (
        //   <>
        //     <MDTypography
        //       component="a"
        //       href="#"
        //       variant="caption"
        //       sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
        //       fontWeight="medium"
        //       onClick={() => handleToggleBackdrop(item, "edit")}
        //     >
        //       Edit
        //     </MDTypography>
        //   </>
        // ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={12} lg={12}>
            {/* <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Clients Management
                </MDTypography>
              </MDBox> */}

            <MDBox pt={3}>
              {(me?.role === "super_admin" ||
                me?.role === "admin" ||
                me?.role === "agent") && (
                <MDBox p={2} mt="auto" display="flex" justifyContent="end">
                  <MDButton
                    component="a"
                    href="#"
                    rel="noreferrer"
                    variant="gradient"
                    color="light"
                    onClick={() =>
                      handleToggleBackdrop(
                        {
                          _id: "",
                          name: "",
                          email: "",
                          phone: "",
                          idNumber: "",
                          date_of_birth: "",
                          profile_image: "",
                          active: false,
                          products: [],
                          complaints: [],
                        },
                        ""
                      )
                    }
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;New Client
                  </MDButton>
                </MDBox>
              )}
              <DataTable
                table={{
                  columns: [
                    {
                      Header: "clients",
                      accessor: "clients",
                      width: "30%",
                      align: "left",
                    },
                    {
                      Header: "phone",
                      accessor: "phone",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "joined",
                      accessor: "joined",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "orders",
                      accessor: "orders",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "complaints",
                      accessor: "complaints",
                      width: "15%",
                      align: "left",
                    },
                    {
                      Header: "verified",
                      accessor: "verified",
                      align: "center",
                    },
                    { Header: "state", accessor: "state", align: "center" },
                  ],

                  rows: renderRows(clientsList),
                }}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={true}
                // noEndBorder
              />
            </MDBox>
            {/* </Card> */}
          </Grid>
        </Grid>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Client Config"
        onCompleteConfig={handleSubmitClient}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Name",
            placeholderType: "Enter Name",
            dataType: "text",
            keyType: "name",
            valueType: currentData?.name,
          },
          {
            labelType: "Email",
            placeholderType: "Enter Email",
            dataType: "email",
            keyType: "email",
            valueType: currentData?.email,
          },
          {
            labelType: "Phone",
            placeholderType: "Enter Phone",
            dataType: "phone",
            keyType: "phone",
            valueType: currentData?.phone,
          },
          {
            labelType: "National ID Number",
            placeholderType: "Enter National ID Number",
            dataType: "text",
            keyType: "idNumber",
            valueType: currentData?.idNumber,
          },
          {
            labelType: "D.O.B",
            placeholderType: "Choose Date of Birth",
            dataType: "date",
            keyType: "date_of_birth",
            valueType: currentData?.date_of_birth,
          },
          {
            labelType: "Profile Image",
            placeholderType: "Enter Profile Image",
            dataType: "image",
            keyType: "profile_image",
            valueType: currentData?.profile_image,
          },
          // {
          //   labelType: "Active",
          //   placeholderType: "Active",
          //   dataType: "active",
          //   keyType: "active",
          //   valueType: currentData?.active,
          // },
        ]}
        state={currentState}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Clients;
